import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { Box } from 'atoms';
import { Shimmer, NoData } from 'components';
import { Dashboard, CollectionHeader, InvoiceSearch } from 'components/pages/collection';
import {
	getInvoices,
	getBanks,
	getReasons,
	clearCheckList,
	setAdditionalFilter,
	setIsAccordionOpen,
	setPanelKey,
} from 'store/invoiceSlice';
import { setNotifications } from 'store/notificationSlice';
import { useQueryParams } from 'hooks';
import MyCollections from './MyCollections';
import AccordionHeader from 'components/common/AccordionHeader';
import { AR } from 'utils/constants';

const { Panel } = Collapse;

const Container = styled(Box)`
	background-color: ${(props) => props.theme.colors.Cultured};
`;

export default function Collection() {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const {
		invoices = [],
		filteredInvoices = [],
		additionalFilter,
		isAccordionOpen,
		panelKey,
	} = useSelector((state) => state.invoice);

	const [showShimmer, setShowShimmer] = useState(true);
	const { salesmanId = undefined } = useQueryParams();
	const { me = {} } = useSelector((state) => state.user);
	const { invoiceDate } = useSelector((state) => state.app);

	if (additionalFilter) {
		dispatch(setAdditionalFilter(false));
	}
	useEffect(() => {
		// clear checkbox current state
		dispatch(clearCheckList());

		// clear notifications
		dispatch(setNotifications([]));

		// dispatch(getNotifications(salesmanId));
	}, [dispatch, me?.type, salesmanId]);

	useEffect(() => {
		/**
		 * On Additional resource login, in collection page if salesmanId id
		 * not available then redirect to salesmen list page
		 */
		if (me?.type === AR && !salesmanId) {
			history.push('sales-men');
		}
	}, [me?.type, salesmanId, history, location]);

	useEffect(() => {
		dispatch(getInvoices(salesmanId));
		dispatch(getBanks());
		dispatch(getReasons());
		setTimeout(() => {
			setShowShimmer(false);
		}, 3000);
	}, [salesmanId, dispatch, me?.type, invoiceDate]);

	useEffect(() => {
		dispatch(setIsAccordionOpen(false));
		dispatch(setPanelKey(['1']));
	}, [dispatch]);

	const accordionStatus = (e) => {
		dispatch(setIsAccordionOpen(!isAccordionOpen));
		dispatch(setPanelKey(e));
	};

	return (
		<Container>
			<CollectionHeader />
			<Dashboard />
			{invoices?.length > 0 && <InvoiceSearch />}
			{showShimmer ? (
				<Shimmer />
			) : (
				<Box mx={2} mt={2} className="collapse__card">
					<Collapse
						style={{ background: 'none' }}
						activeKey={panelKey}
						onChange={accordionStatus}
					>
						{/* My Collections */}
						<Panel
							key="1"
							header={
								<AccordionHeader
									title="My Collections"
									invoiceCount={filteredInvoices?.length}
								/>
							}
						>
							<MyCollections />
						</Panel>
					</Collapse>
				</Box>
			)}
		</Container>
	);
}

NoData.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
